import moment from 'moment-timezone'

import { uuidv4 } from '@/lib/utils'

import submitPlatformPost from '@/graphql/mutations/submissions/submitPlatformPost.gql'
import reschedulePlatformPost from '@/graphql/mutations/submissions/reschedulePlatformPost.gql'
import deletePlatformPost from '@/graphql/mutations/submissions/deletePlatformPost.gql'
import duplicatePlatformPost from '@/graphql/mutations/submissions/duplicatePlatformPost.gql'

import allTumblrSubmissions from '@/graphql/queries/tumblr/allTumblrSubmissions.gql'
import tumblrPost from '@/graphql/queries/tumblr/tumblrPost.gql'

export default {
  code: 'tumblr',
  name: 'Tumblr',
  icon: 'tumblr',
  color: '#001935',
  accountNoun: 'Blog',
  postNoun: 'Post',
  internalPostNoun: 'TumblrPost',
  mutations: {
    submitPost: submitPlatformPost,
    submitPostVariables: (submission) => {
      return {
        postId: submission.postId,
        platform: submission.platform.toUpperCase()
      }
    },
    deletePost: deletePlatformPost,
    deletePostVariables: (submission) => {
      return {
        postId: submission.postId,
        platform: submission.platform.toUpperCase()
      }
    },
    reschedulePost: reschedulePlatformPost,
    reschedulePostVariables: (submission) => {
      return {
        postId: submission.postId,
        platform: submission.platform.toUpperCase()
      }
    },
    duplicatePost: duplicatePlatformPost
  },
  queries: {
    allSubmissions: allTumblrSubmissions,
    getPost: tumblrPost
  },
  posts: {
    preparePostForScheduling: (post, publishingStatus = 'READY_TO_PUBLISH') => {
      return {
        id: post.id,
        username: post.username,
        content: JSON.stringify(post.content),
        layout: JSON.stringify(post.layout),
        tags: post.tags,
        communityLabel: post.communityLabel,
        sourceUrl: post.sourceUrl,
        submissions: post.submissions.map((submission) => {
          return {
            id: submission.id,
            postAt: submission.postAt
          }
        }),
        publishingStatus
      }
    },
    createPost(socialAccount) {
      return {
        id: null,
        username: socialAccount.username,
        content: [
          {
            id: uuidv4(),
            type: 'text',
            text: '',
            subtype: 'heading1'
          },
          {
            id: uuidv4(),
            type: 'text',
            text: ''
          }
        ],
        layout: [],
        tags: [],
        communityLabel: 'FOR_EVERYONE',
        sourceUrl: '',
        publishingStatus: 'READY_TO_PUBLISH',
        submissions: [
          { postAt: moment().add(1, 'hour').startOf('hour').toDate() }
        ]
      }
    },
    getPost(post) {
      if (typeof post.content === 'string') {
        post.content = JSON.parse(post.content)
      }

      const headingBlock = getFirstBlockOfType(post, 'text', 'heading1')
      let caption = headingBlock ? headingBlock.text : ''

      const textBlock = getFirstBlockOfType(post, 'text')
      let text = textBlock ? textBlock.text : ''

      return {
        caption,
        text,
        gallery: null,
        postAt: moment(post.submissions[0].postAt).toDate()
      }
    },
    syncField(post, field, value, socialAccount) {
      if (field === 'caption') {
        let block = createTextBlock(post, value, 'heading1')
        addOrReplaceBlockOfTypeAndSubtype(post, 'text', 'heading1', block)
      } else if (field === 'text') {
        let block = createTextBlock(post, value)
        addOrReplaceBlockOfType(post, 'text', block)
      } else if (field === 'gallery') {
        // We don't support galleries for Tumblr yet
      } else if (field === 'postAt') {
        post.submissions[0].postAt = value
      } else if (field === 'thread') {
        if (value.length > 0) {
          let text = value[0].text
          if (text) {
            let block = createTextBlock(post, text)
            addOrReplaceBlockOfType(post, 'text', block)
          }
        }
      }
      return post
    }
  }
}

function getFirstBlockOfType(post, type, subtype = null) {
  return post.content.find((block) => {
    return block.type === type && (subtype ? block.subtype === subtype : true)
  })
}

function addBlock(post, block, index = null) {
  block.id = uuidv4()

  if (typeof index === 'number') {
    post.content.splice(index, 0, block)
  } else {
    post.content.push(block)
  }
}

function addOrReplaceBlockOfType(post, type, block) {
  const existingBlockIndex = post.content.findIndex((b) => b.type === type)
  if (existingBlockIndex !== -1) {
    block.id = uuidv4()
    post.content.splice(existingBlockIndex, 1, block)
  } else {
    addBlock(post, block)
  }
}

function addOrReplaceBlockOfTypeAndSubtype(post, type, subtype, block) {
  const existingBlockIndex = post.content.findIndex(
    (b) => b.type === type && b.subtype === subtype
  )
  if (existingBlockIndex !== -1) {
    block.id = uuidv4()
    post.content.splice(existingBlockIndex, 1, block)
  } else {
    addBlock(post, block)
  }
}

function createTextBlock(post, text = '', subtype = '', index = null) {
  const textBlock = {
    type: 'text',
    subtype: typeof subtype === 'string' ? subtype : '',
    text: text || ''
  }
  return textBlock
}

function createImageBlock(post, media, index = null) {
  const imageBlock = {
    type: 'image',
    media: [],
    alt_text: '',
    caption: ''
  }
  return imageBlock
}
function createVideoBlock(post, media, index = null) {
  const videoBlock = {
    type: 'video',
    media: {
      type: '',
      url: ''
    }
  }
  return videoBlock
}
